<script>
    import R, {LOADER} from "../lib/requests";
    import {formatDate, setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import InputAutosize from "../components/controls/InputAutosize.svelte";
    import ProjectSelectControl from "../components/controls/ProjectSelectControl.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import TimeControl from "../components/controls/TimeControl.svelte";
    import DurationControl from "../components/controls/DurationControl.svelte";
    import TagsControl from "../components/controls/TagsControl.svelte";
    import TaskPriceControl from "./TaskPriceControl.svelte";
    import ChargeComponent from "../charges/ChargeComponent.svelte";
    import Notifier from "../stores/notifier";
    import {OBJECTS} from "../lib/constants";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let taskId = null;
    export let closeCallback;

    let task = null;
    let modalTitle = 'Εργασία';
    let project = null;
    let startDate = null;
    let endDate = null;
    let startTime = null;
    let endTime = null;
    let charge = null;


    const initialize = () => {
        if (!taskId) {
            let dt1 = new Date();
            let dt2 = new Date(dt1);
            dt2.setMinutes(dt1.getMinutes() + 30);

            task = {
                id: 0,
                name: '',
                start_at: formatDate(dt1, 'y-m-d H:i:d'),
                end_at: formatDate(dt2, 'y-m-d H:i:d'),
                duration: new Date(dt2) - new Date(dt1),
                price: null,
                project_id: 0,
                tags: [],
            };

            modalTitle = "Νέα εργασία";
            setTaskData();
            setFocusTo('taskName');
        } else {
            load();
        }
    }

    const load = () => {
        const onSuccess = result => {
            task = result;
            project = task.project;
            delete (task.project);
            if (project) {
                project.is_billable = project.min_price || project.price_per_hour;
            }
            setTaskData();
            setFocusTo('taskName');
        }

        const onFailure = err => {
            // Alert.warning("Χρέωση", err.message);
        };

        R.handle(R.task.details, taskId, onSuccess, onFailure, LOADER.POPUP);
    }

    const save = () => {

        const onSuccess = result => {
            task = result
            Notifier.showMessage("Η εργασία ενημερώθηκε");
            if (charge) {
                saveCharge();
            } else {
                close(task);
            }
        }

        const onFailure = err => {
            if (err.code && err.code === 'not_defined') {
                if (err.params.object === 'project') {
                    Notifier.showError("Δεν έχει οριστεί project για την εργασία!");
                    setFocusTo('taskProject');
                    return;
                }
            }
        };


        task.name = task.name.trim();
        if (!task.name) {
            Notifier.showError("Η εργασία δεν έχει όνομα!");
            setFocusTo('taskName');
            return;
        }

        if (task.project_id == 0) {
            Notifier.showError("Επιλέξτε ένα project για την εργασία!");
            setFocusTo('taskProject');
            return;
        }

        task.start_at = `${startDate} ${startTime}`;
        task.end_at = `${endDate} ${endTime}`;

        if (task.is_billable == 0) {
            task.use_current_project_prices = 0;
        }

        let action = taskId == 0 ? 'create' : 'edit';
        R.handle(R.task[action], task, onSuccess, onFailure);
    }


    const setTaskData = () => {
        startDate = formatDate(task.start_at, 'y-m-d');
        startTime = formatDate(task.start_at, 'H:i:d');
        endDate = formatDate(task.end_at, 'y-m-d');
        endTime = formatDate(task.end_at, 'H:i:d');
    }


    const close = (param) => {
        task = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    const onProjectChange = ({detail}) => {
        project = detail;

        // if (!task.id) {
        //     task.is_billable = project.is_billable ? 1 : 0;
        // }
    }

    const onDateChange = ({detail}) => {
        startDate = detail;
        task.start_at = `${startDate} ${startTime}`;
        let dt = new Date(task.start_at);
        dt.setMilliseconds(dt.getMilliseconds() + task.duration);
        task.end_at = formatDate(dt, 'y-m-d H:i:s');
        setTaskData();
    }

    const onStartTimeChange = ({detail}) => {
        startTime = detail;
        task.start_at = `${startDate} ${startTime}`;
        let dt = new Date(task.start_at);
        dt.setMilliseconds(dt.getMilliseconds() + task.duration);
        task.end_at = formatDate(dt, 'y-m-d H:i:s');
        setTaskData();
    }

    const onEndTimeChange = ({detail}) => {
        endTime = detail;
        task.end_at = `${endDate} ${endTime}`;
        task.duration = new Date(task.end_at) - new Date(task.start_at);
        setTaskData();
    }

    const onDurationChange = ({detail}) => {
        task.duration = detail;
        let dt = new Date(task.start_at);
        dt.setMilliseconds(dt.getMilliseconds() + task.duration);
        task.end_at = formatDate(dt, 'y-m-d H:i:s');
        setTaskData();
    }

    /* Task charge handlers */
    const showCharge = () => {
        charge = {
            id: 0,
            object_type: OBJECTS.TASK,
            project_id: task.project_id,
            name: task.name,
            price: task.price || null,
            payment: null,
        }
    }

    const onDeleteCharge = () => {
        charge = null;
    }

    const saveCharge = () => {
        const onSuccess = result => {
            task.charge_id = result.id;
            close(task);
        }

        const onFailure = err => {
        };

        charge.object_id = task.id;

        R.handle(R.charge.create, charge, onSuccess, onFailure, LOADER.POPUP);
    }

    initialize();

    $: {
        if (task && charge) {
            charge.project_id = task.project_id;
            charge.name = task.name;
            charge.price = task.price;
        }
    }
</script>

{#if task}
    <Modal title="{ modalTitle }" icon="clock" modalSm closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Εργασία</label>
                <InputAutosize id="taskName" css="form-control" bind:value="{ task.name }"/>
            </div>
            <div class="form-group">
                <label>Project</label>
                <ProjectSelectControl id="taskProject" bind:projectId={ task.project_id } {project}
                                      on:change="{ onProjectChange }"/>
            </div>

            <label>Ημερομηνία</label>
            <div class="from-to form-group">
                <div class="from">
                    <DateControl bind:value="{ startDate }" on:change={ onDateChange } hideClear/>
                </div>
                {#if endDate !== startDate}
                    <div class="to">
                        <div class="form-control">
                            { formatDate(endDate, 'd-m-y') }
                        </div>
                    </div>
                    <div class="range">-</div>
                {/if}
            </div>
            <label>Διάρκεια</label>
            <div class="row form-group">
                <div class="col-6">
                    <div class="from-to">
                        <div class="from">
                            <TimeControl time="{ startTime }" css="text-center px-0" on:change="{ onStartTimeChange }"
                                         disabled="{ task.charge_id }"/>
                        </div>
                        <div class="to">
                            <TimeControl time="{ endTime }" css="text-center px-0" on:change="{ onEndTimeChange }"
                                         disabled="{ task.charge_id }"/>
                        </div>
                        <div class="range">-</div>
                    </div>
                </div>
                <div class="col-6">
                    <DurationControl duration="{ task.duration}" on:change="{ onDurationChange }"
                                     disabled="{ task.charge_id }"/>
                </div>
            </div>
            <div class="form-group mb-4">
                <label>Χρέωση</label>
                <TaskPriceControl bind:value={task.price} projectId={task.project_id} duration={task.duration}
                                  disabled={task.charge_id}/>
                {#if task.charge_id}
                    <div class="text-info">
                        Έχετε δημιουργήσει χρέωση για αυτή την εργασία
                    </div>
                {/if}
            </div>
            <div class="form-group">
                <TagsControl bind:tags={ task.tags } clockingTask/>
            </div>

            {#if !task.charge_id}
                {#if charge == null}
                    <button class="btn btn-default btn-block btn-sm" on:click={showCharge}>Δημιουργία χρέωσης</button>
                {:else}
                    <div class="panel panel-default">
                        <div class="panel-heading fw-semibold pe-0">
                            <h6 class="mb-0">Στοιχεία χρέωσης</h6>
                            <button class="btn" on:click={onDeleteCharge}>
                                <AppIcon icon="x" strokeWidth="2"/>
                            </button>
                        </div>
                        <div class="panel-body pt-3">
                            <ChargeComponent bind:charge disableName disablePrice/>
                        </div>
                    </div>
                {/if}
            {/if}

            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary" on:click={ save }>Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .from-to {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .from-to .from, .from-to .to {
        width: calc(50% - 12px);
        text-align: center;
    }

    .from-to .range {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>